import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Phone, Clock, Users, Activity } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface OverviewData {
  totalSessions: number;
  todaySessions: number;
  activeSessions: number;
  avgDuration: number;
}

interface VoiceAgentStatsCardsProps {
  overview: OverviewData | undefined;
  isLoading: boolean;
  formatDuration: (seconds: number) => string;
}

const VoiceAgentStatsCards = ({ overview, isLoading, formatDuration }: VoiceAgentStatsCardsProps) => {
  const stats = [
    {
      title: "Total Sessions",
      value: overview?.totalSessions || 0,
      icon: Phone,
      description: "All-time conversations",
      color: "text-blue-500",
      bgColor: "bg-blue-500/10",
    },
    {
      title: "Today's Sessions",
      value: overview?.todaySessions || 0,
      icon: Activity,
      description: "Conversations today",
      color: "text-green-500",
      bgColor: "bg-green-500/10",
    },
    {
      title: "Active Now",
      value: overview?.activeSessions || 0,
      icon: Users,
      description: "Live conversations",
      color: "text-orange-500",
      bgColor: "bg-orange-500/10",
    },
    {
      title: "Avg. Duration",
      value: formatDuration(overview?.avgDuration || 0),
      icon: Clock,
      description: "Per conversation",
      color: "text-purple-500",
      bgColor: "bg-purple-500/10",
      isFormatted: true,
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <Card key={stat.title}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {stat.title}
            </CardTitle>
            <div className={`p-2 rounded-lg ${stat.bgColor}`}>
              <stat.icon className={`h-4 w-4 ${stat.color}`} />
            </div>
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <Skeleton className="h-8 w-24" />
            ) : (
              <>
                <div className="text-2xl font-bold">
                  {stat.isFormatted ? stat.value : stat.value.toLocaleString()}
                </div>
                <p className="text-xs text-muted-foreground mt-1">
                  {stat.description}
                </p>
              </>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default VoiceAgentStatsCards;
